<template>
  <div class="t-input">
    <div class="t-input__wrapper">
      <input
        class="t-input__element"
        :name="name"
        :placeholder="placeholder"
        :readonly="readonly"
        :disabled="disabled"
        :type="nativeType"
        v-model="computedValue"
        @blur="$emit('blur', $event)"
        @focus="$emit('focus', $event)"
        @change="$emit('change', $event)"
      >
      <span v-if="$slots.left" class="t-input__prefix"><slot name="left"></slot></span>
      <span v-if="$slots.right" class="t-input__suffix"><slot name="right"></slot></span>
      <span class="t-input__seperator"></span>
    </div>
  </div>
</template>

<script>
import { inputTypes } from '../../enums';
import ValidatableMixin from '../../mixins/ValidatableMixin';

export default {
  name: 't-input',

  mixins: [ValidatableMixin],

  props: {
    name: String,
    disabled: Boolean,
    readonly: Boolean,
    placeholder: String,
    value: [String, Number],
    nativeType: {
      type: String,
      default: inputTypes.TEXT,
      validator: (value) => Object.values(inputTypes).includes(value),
    },
  },

  data() {
    return {
      newValue: this.value,
    };
  },

  computed: {
    computedValue: {
      get() {
        return this.newValue;
      },
      set(value) {
        this.newValue = value;
        this.$emit('input', value);
      },
    },
  },

  watch: {
    value(value) {
      this.newValue = value;
    },
  },
};
</script>
